// extracted by mini-css-extract-plugin
module.exports = {"content":"LandscapeFullScreen_content__1brJ2"};